import { error } from '@ms/yammer-console-logging';

export const getKeys = (): string[] => {
  const keys: string[] = [];
  const count = sessionStorage.length;
  for (let index = 0; index < count; index++) {
    const key = sessionStorage.key(index);
    if (key != null) {
      keys.push(key);
    }
  }

  return keys;
};

type GetItem = <T>(key: string) => T | null;
export const getItem: GetItem = (key: string) => {
  const item = sessionStorage.getItem(key);

  return item ? JSON.parse(item) : null;
};

type SetItem = <T>(key: string, item: T) => void;
export const setItemOrThrow = (key: string, item: unknown): void => {
  sessionStorage.setItem(key, JSON.stringify(item));
};

export const setItem: SetItem = <T>(key: string, item: T) => {
  try {
    setItemOrThrow(key, item);
  } catch (e) {
    error(e);
  }
};

type RemoveItem = (key: string) => void;
export const removeItem: RemoveItem = (key: string) => {
  sessionStorage.removeItem(key);
};
